import { DeviceCategoryEnum } from "@gtpl/shared-models/masters";
import { ApiProperty } from "@nestjs/swagger";

export class DeviceCategoryAndDeptNameRequest {
    @ApiProperty()
    deptName: string;
    @ApiProperty()
    deviceCategory: DeviceCategoryEnum;
    @ApiProperty()
    plantId: number;
}